export const ERR_DEFAULT = 'default';
